import styled from 'styled-components'
import { Flyout } from 'common-components'
import { COLORS } from 'consts/colors'
import { getRatingColor } from '../ratingColor'

export {
  SubmenuFlyout,
  GroupItemWrapper,
  GroupItemHeader,
  GroupItemTitle,
  GroupChevron,
  ProviderIconFallback,
  SubmenuPanel,
  SubmenuVariantWrapper,
  SubmenuVariantHeader,
  SelectedCheck,
  MobileSubmenuWrapper,
  CrownBadgeIcon
} from 'containers/SubSidebar/shared/GroupedModelDropdown/ModelGroupItem/styled'

export const MetaRow = styled.div`
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  gap: 4px;
`

export const GroupRowFlex = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
`

export const GroupRowContent = styled.div`
  display: flex;
  flex-direction: column;
  flex: 1;
  min-width: 0;
  gap: 6px;
`

export const TitleLine = styled.div`
  display: flex;
  align-items: center;
  gap: 2px;
  min-width: 0;
`

export const IconTile = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 40px;
  height: 40px;
  border-radius: 8px;
  border: 1px solid ${COLORS.borderColor};
  background-color: ${COLORS.white};
`

export const UnlimitedBadge = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 2px 8px;
  border-radius: 4px;
  margin-left: 4px;
  border: none;
  cursor: pointer;
  background: ${COLORS.purple};
`

export const InfoIconAnchor = styled.div`
  display: inline-flex;
  align-items: center;
  justify-content: center;
`

export const TooltipPanel = styled.div<{ $viewportShiftPx: number }>`
  position: relative;
  width: 310px;
  padding: 16px;
  border-radius: 8px;
  background-color: ${COLORS.secondaryExtraDark};
  color: ${COLORS.white};
  box-shadow: 0 12px 32px rgba(37, 46, 72, 0.24);
  transform: translateX(
    calc(-50% + 10px + ${({ $viewportShiftPx }) => $viewportShiftPx}px)
  );
`

export const InfoTooltipFlyout = styled(Flyout)`
  box-shadow: none;
  background: transparent;
  border-radius: 0;
`

export const TooltipArrow = styled.div<{
  $side: 'top' | 'bottom'
  $viewportShiftPx: number
}>`
  position: absolute;
  left: 50%;
  transform: translateX(
    calc(-50% - ${({ $viewportShiftPx }) => $viewportShiftPx}px)
  );
  width: 0;
  height: 0;
  border-left: 6px solid transparent;
  border-right: 6px solid transparent;
  ${({ $side }) =>
    $side === 'bottom'
      ? `
        bottom: -6px;
        border-top: 6px solid ${COLORS.secondaryExtraDark};
      `
      : `
        top: -6px;
        border-bottom: 6px solid ${COLORS.secondaryExtraDark};
      `}
`

export const DescriptionWrapper = styled.div`
  margin-top: 8px;
`

export const TooltipDivider = styled.hr`
  margin: 8px 0;
  border: 0;
  border-top: 1px solid rgba(255, 255, 255, 0.12);
`

export const QualityRow = styled.div`
  display: flex;
  align-items: center;
  gap: 10px;
`

export const QualityBarTrack = styled.div`
  flex: 1;
  height: 6px;
  border-radius: 3px;
  background-color: rgba(255, 255, 255, 0.18);
  overflow: hidden;
`

export const QualityBarFill = styled.div<{ $score: number }>`
  height: 100%;
  width: ${({ $score }) => Math.max(0, Math.min(100, $score * 10))}%;
  background-color: ${({ $score }) => getRatingColor($score)};
  border-radius: 3px;
`
